<template>
<div class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
        <p class="modal-card-title">{{ header }}</p>
        <button class="delete is-medium" aria-label="close" @click="$emit('close')"></button>
    </header>
    <section class="modal-card-body" v-if="kind == 'addField' || kind == 'addPage' || kind == 'addSetting'">
        <template v-if="kind == 'addField'">

          <div class="field">
            <p class="heading">Property Name</p>
            <div class="control is-fullwidth">
              <input type="text" class="input"  :placeholder="'Property'" v-model="fieldName">
            </div>
          </div>
          <div class="field">
            <p class="heading">Field Type</p>
            <div class="control is-fullwidth">
              <div class="select is-fullwidth">
                <select v-model="fieldType">
                  <option v-for="(type, index) in fieldTypes" :key="index" :value="type">{{type}}</option>
                </select>
              </div>
            </div>
          </div>
        </template>
       <input type="text" class="input" v-if="kind == 'addPage'" :placeholder="'Page'" v-model="pageName">
       <input type="text" class="input" v-if="kind == 'addSetting'" :placeholder="'Setting'" v-model="settingName">
    </section>
    <footer class="modal-card-foot" v-if="kind == 'logout'">
      <button class="button is-success" @click="$emit('confirmLogout')">Logout</button>
      <button class="button" @click="$emit('close')">Cancel</button>
    </footer>
    <footer class="modal-card-foot" v-else>
      <template v-if="kind == 'deletePage' || kind == 'deleteField' || kind == 'deleteSetting' || kind == 'deletePost' || kind == 'bulkDeleteSelected'">
        <button class="button is-success" @click="deleteObj()">Confirm</button>
      </template>
      <template v-else>
        <button class="button is-success" @click="add()">Add</button>
      </template>
      <button class="button" @click="$emit('close')">Cancel</button>
    </footer>
  </div>
</div>
</template>

<script>
export default {
  name: 'modal',
  data () {
    return {
      fieldType: 'text',
      fieldName: '',
      pageName: '',
      settingName: '',
      fieldTypes: [
        'text',
        'richtext',
        'image',
        'gallery'
      ]
    }
  },
  methods: {
    add (event) {
      if (this.kind === 'addField') {
        this.$emit(
          'addField',
          {
            fieldName: this.fieldName,
            fieldType: this.fieldType
          }
        )
      }
      if (this.kind === 'addPage') { this.$emit('addPage', this.pageName) }
      if (this.kind === 'addSetting') { this.$emit('addSetting', this.settingName) }
    },
    deleteObj () {
      if (this.kind === 'deleteField') { this.$emit('confirmDeleteField') }
      if (this.kind === 'deletePage') { this.$emit('confirmDeletePage') }
      if (this.kind === 'deleteSetting') { this.$emit('confirmDeleteSetting') }
      if (this.kind === 'deletePost') { this.$emit('confirmDeletePost') }
      if (this.kind === 'bulkDeleteSelected') { this.$emit('selectBulkActions') }
    }
  },
  props: {
    header: {
      type: String,
      required: true,
      default: '!Error'
    },
    subHeader: {
      type: String,
      required: false,
      default: '!Error'
    },
    kind: {
      type: String
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Modal.vue